import React, { useEffect, useRef, useState } from "react";

/*
	Promociones flexibles (docs/ESPEC_PROMOS_FLEXIBLES.md): «Termina en 2 d 4 h» donde se elige la promo (paso Promoción, Registrar
	Pago, Descuentos). El fin viene del servidor en ISO con la zona del plantel; se corrige el reloj del teléfono con la hora del
	servidor. Al llegar a cero avisa (onExpire) para que la pantalla la quite sola, sin recargar a mano.
*/

export const restante = (ms: number): string => {
	if (ms <= 0) return "Terminó";
	const min = Math.floor(ms / 60000);
	const d = Math.floor(min / 1440);
	const h = Math.floor((min % 1440) / 60);
	const m = min % 60;
	if (d > 0) return "Termina en " + d + " d" + (h ? " " + h + " h" : "");
	if (h > 0) return "Termina en " + h + " h" + (m ? " " + m + " min" : "");
	if (min > 0) return "Termina en " + m + " min";
	return "Termina en " + Math.max(1, Math.ceil(ms / 1000)) + " s";
};

/** Diferencia entre el reloj del servidor y el del navegador (ms). */
export const desfase = (serverNowIso?: string | null): number => (serverNowIso ? Date.parse(serverNowIso) - Date.now() : 0);

export const CuentaRegresiva: React.FC<{ toIso?: string | null; serverNowIso?: string | null; onExpire?: () => void; compacta?: boolean }> = ({ toIso, serverNowIso, onExpire, compacta }) => {
	const fin = toIso ? Date.parse(toIso) : NaN;
	const ajuste = useRef<number>(desfase(serverNowIso));
	const [ahora, setAhora] = useState<number>(Date.now() + ajuste.current);
	const avisado = useRef<boolean>(false);
	useEffect(() => {
		if (!isFinite(fin)) return;
		const falta = fin - (Date.now() + ajuste.current);
		const paso = falta < 10 * 60000 ? 1000 : 30000;
		const t = setInterval(() => setAhora(Date.now() + ajuste.current), paso);
		return () => clearInterval(t);
	}, [fin, ahora < fin - 10 * 60000]);
	useEffect(() => {
		if (isFinite(fin) && ahora >= fin && !avisado.current) {
			avisado.current = true;
			onExpire && onExpire();
		}
	}, [ahora, fin, onExpire]);
	if (!isFinite(fin)) return null;
	const ms = fin - ahora;
	const urgente = ms < 24 * 3600 * 1000;
	return (
		<span className="waCuentaRegresiva" style={{ display: "inline-block", fontSize: compacta ? 12 : 13, fontWeight: 700, padding: "1px 8px", borderRadius: 999,
			background: urgente ? "var(--wa-oro-suave)" : "var(--wa-acento-suave)", color: urgente ? "var(--wa-oro)" : "var(--wa-acento-texto)", whiteSpace: "nowrap" }}>
			{restante(ms)}
		</span>
	);
};

/** «Quedan 3 de 10 este mes» / «Agotada este mes» (lo arma el servidor). */
export const CupoTexto: React.FC<{ quota?: any; compacta?: boolean }> = ({ quota, compacta }) => {
	if (!quota || !quota.text) return null;
	return (
		<span style={{ display: "inline-block", fontSize: compacta ? 12 : 13, fontWeight: 700, padding: "1px 8px", borderRadius: 999,
			background: quota.exhausted ? "var(--wa-oro-suave)" : "var(--wa-papel)", color: quota.exhausted ? "var(--wa-oro)" : "var(--wa-tinta)",
			border: quota.exhausted ? "0" : "1px solid var(--wa-filo)", whiteSpace: "nowrap" }}>
			{quota.text}
		</span>
	);
};

export default CuentaRegresiva;
